import { Pipe, PipeTransform } from '@angular/core';
import orderBy from 'lodash/orderBy';
import { PortfolioManager } from '@capital-access/ownership/common';

@Pipe({
  name: 'orderPortfolioManagers',
  standalone: true
})
export class OrderPortfolioManagersPipe implements PipeTransform {
  transform(managers: PortfolioManager[]): PortfolioManager[] {
    return orderBy(
      managers.map(manager => ({
        ...manager,
        isPrimary: !!manager.isPrimary // ensure 'isPrimary' field is present for proper ordering
      })),
      ['isPrimary', item => item?.name?.toLowerCase()],
      ['desc', 'asc']
    );
  }
}
